<!--盘点单list-->
<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <!--<el-input style="width:200px;"-->
            <!--placeholder="请输入内容"-->
            <!--prefix-icon="el-icon-search"-->
            <!--v-model="searchdata">-->
            <!--</el-input>-->
            <el-col :span="10">
              <span class="demonstration">开始日期</span>
              <el-date-picker style="width:150px"
                              v-model="begindate" :value-format="'yyyy-MM-dd'" size="mini"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
              <span class="demonstration">结束日期</span>
              <el-date-picker style="width:150px"
                              v-model="enddate" :value-format="'yyyy-MM-dd'" size="mini"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </el-col>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
            <el-dropdown style="margin-left: 20px" @command="handleDropCommand" v-if="pandian&&!bimanage">
              <el-button type="warning" icon="el-icon-edit"  size="mini">
                盘点
              </el-button>
              <el-dropdown-menu slot="dropdown" style="font-size: larger">
                <el-dropdown-item command="lens"> 镜 片 </el-dropdown-item>
                <el-dropdown-item command="frame"> 镜 架 </el-dropdown-item>
                <el-dropdown-item command="other"> 其 他 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="warning" v-on:click="excelPort" size="mini">导出</el-button>
            <el-checkbox v-model="showdifference">仅导出差异数</el-checkbox>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(115)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column type="index" width="50" label="序号" align="center">
          </el-table-column>
          <el-table-column
            prop="physicalstore" :show-overflow-tooltip="true"
            align="left"
            header-align="center"
            label="名称" >
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="physicalstorecode"-->
            <!--align="left"-->
            <!--header-align="center"-->
            <!--label="编码" width="130">-->
          <!--</el-table-column>-->
          <el-table-column
            align="center" :show-overflow-tooltip="true"
            label="盘点日期" width="110">
            <template slot-scope="scope">
              {{(scope.row.accdate || "").substring(0,10)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="erpserial"
            label="单号" :show-overflow-tooltip="true"
            align="center"
            header-align="center"
            width="120">
          </el-table-column>
          <el-table-column
            prop="needaudit"
            label="状态"
            align="center"
            header-align="center"
            width="80">
            <template slot-scope="scope">
            <span style="color: red" v-if="scope.row.needaudit==1"><b>待审核</b></span>
              <span style="color: #00BDFF" v-else-if="scope.row.needaudit==-1"><b>驳回</b></span>
            <span v-else>已生效</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="cangkuname" :show-overflow-tooltip="true"
            label="仓库"
            align="center"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="uname"
            label="姓名"
            align="center" :show-overflow-tooltip="true"
            width="80"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="left"
            header-align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="lookDetails(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>
        <MakeInventorySwitch ref="MakeInventorySwitch1" @bindGrid="bindGrid"></MakeInventorySwitch>
      </div>
    </el-col>

  </div>
</template>

<script>
  import {getListData,loadMakeInventory} from '@/api/set/warehouse';
  import MakeInventorySwitch from './MakeInventorySwitch';

  export default {
    name: 'MakeInventory',
    msg: '盘点单',
    data() {
      return {
        msg: 'Welcome to Your Vue.js Ap22p',
        dialogFormVisible: false,
        searchdata: "",
        begindate: this.begindate,
        enddate: this.enddate,
        loading: true,
        bimanage: false,
        status: "",
        seedcode: "",
        dataname: "",
        pandian: false,
        seedgoods: '',
        showdifference:false,
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        controlData: {}
      }
    },
    props: {
      cangkucodes: {type: Array, default: () => []},
      cangkuname: {default: ""},
    },
    methods: {
      excelPort() {
        if (!this.begindate) {
          this.$message({
            message: '开始时间必选！',
            type: 'warning'
          })
          return;
        }
        loadMakeInventory({
          begindate: this.begindate,
          enddate: this.enddate, showdifference: this.showdifference ? "1" : ""
        }).then(response => {
          let data = response.data.obj;
          let header1 = ["门店", "区域", "性质", "单号", "时间", "盘点人", "类别", "品牌", "商品名称", "商品编码", "球镜", "柱镜", "型号", "色号", "成本单价", "零售单价", "当前库存", "可用数量", "盘点数量", "差异数量", "差异成本金额", "差异零售金额", "备注"]
          let column1 = ["cangkuname", "region", "nature", "erpserial", "accdate", "uname", "leibie", "pingpai", "seedname", "seedcode", "y", "x", "m", "c", "costprice", "saleprice", "closennum", "canuse", "inventorynum", "handlenumber", "inventorcostprice", "inventorsaleprice", "remark"]

          for(let i in data) {
            if (data[i].packagesize) {
              try {
                var pg = JSON.parse(data[i].packagesize);
                data[i].x=pg.X;
                data[i].y=pg.Y;
                data[i].m=pg.M;
                data[i].c=pg.C;
              } catch (ex) {
              }
            }
          }
          var name = this.begindate;
          if (this.enddate) {
            name += "~" + this.enddate
          }
          name += "盘点单";
          this.$exportExcel(header1, column1, data, name)
        });
      },
      handleDropCommand(command) {
        switch (command) {
          case 'lens':
            this.add();
            break;
          case 'frame':
            this.addFrame();
            break;
          case 'other':
            this.addOther();
            break;
        }
      },
      add() {
        this.$refs.MakeInventorySwitch1.show(this.cangkucodes[0], 'lens')
      },
      addOther() {
        this.$refs.MakeInventorySwitch1.show(this.cangkucodes[0], 'other')
      },
      addFrame() {
        this.$refs.MakeInventorySwitch1.show(this.cangkucodes[0], 'frame')
      },
      lookDetails(index, row) {
        if (row.physicalstorecode && row.casestatus != 80) {//镜片
          if (row.casestatus == 40) {
            this.$refs.MakeInventorySwitch1.initData(row, 'other');
          } else {
            this.$refs.MakeInventorySwitch1.initData(row, 'lens');
          }
        } else {//镜架
          this.$refs.MakeInventorySwitch1.initData(row, 'frame')
        }
      },
      bindGrid() {
        if (!this.begindate) {
          this.$message({
            message: '开始时间必选！',
            type: 'warning'
          })
          return;
        }
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          begindate: this.begindate,
          enddate: this.enddate,
          seedcode: this.seedcode,
          cangkucodes: JSON.stringify(this.cangkucodes),
          formtype: 74,
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      this.bimanage = this.$route.query.bimanage ? true : false;
      this.pandian = this.$checkRight("盘点");
      var da = new Date();
      if (da.getMonth() == 0) {
        this.begindate = (da.getFullYear() - 1) + '-12-1';
      } else {
        this.begindate = da.getFullYear() + "-" + da.getMonth() + '-01';
      }
      this.bindGrid();
    },
    components: {
      MakeInventorySwitch
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventory.vue